import React from 'react';
import CtaLink from './CtaLink';
import AnimatedWords from './AnimatedWords';
import useParallax from '../hooks/useParallax';

const AboutHero = () => {
  const parallaxRef = useParallax(0.5);
  
  return (
    <section ref={parallaxRef} className="hero" style={{ '--hero-bg': "url('/images/about_us_landing.webp')" }}>
      <div className="container hero-inner flex w-full items-center lg:items-start">
        <h1 className="text-4xl md:text-6xl lg:text-[79px]">
          <AnimatedWords lines={["Building the Future of Smart Logistics"]} />
        </h1>
        <div className='flex flex-col gap-10 lg:gap-0 lg:flex-row items-center lg:justify-between w-full'>
          <div className="hero-content-row">
            <p className="lead text-lg md:text-xl lg:text-2xl">
              <AnimatedWords lines={["Empowering companies with end-to-end logistics that are faster, smarter, and built around your needs."]} />
            </p>
          </div>
          <CtaLink href="#about" primaryText="Discover Our Story" ariaLabel="Scroll to about"/>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
